export default __webpack_public_path__ + "static/media/mainBg.ec8e6fae.jpg";